import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams, generatePath } from 'react-router-dom';

import { isAuthorizedSelector } from '@/domain/env';
import ROUTES_PATH from '@/router/routesPathConfig';

import NotFoundContainer from '@/pages/servicePage/components/NotFoundContainer';

const mapStateToProps = (state) => ({
  isAuthorized: isAuthorizedSelector(state),
});

const DocNotFoundPage = () => {
  const { isAuthorized } = useSelector(mapStateToProps);
  const { companyId } = useParams();

  const link = useMemo(() => {
    if (companyId) {
      const path = ROUTES_PATH.COMPANY_WORKSPACE_CATEGORY_UNDEFINED.absolute;
      return generatePath(path, { companyId });
    }
    return isAuthorized ? '/' : generatePath(ROUTES_PATH.AUTH_LOGIN.absolute);
  }, [isAuthorized, companyId]);

  return (
    <NotFoundContainer
      link={link}
      title={{ id: '404.documentNotFoundHeader', defaultMessage: 'Document not found' }}
      description={{ id: '404.documentNotFoundDescription', defaultMessage: '' }}
      buttonText={{ id: '404.documentNotFoundWorkspaceButton', defaultMessage: 'Go to workspace' }}
    />
  );
};

export default DocNotFoundPage;
